import { render, staticRenderFns } from "./templateManage.vue?vue&type=template&id=8324fb30&scoped=true"
import script from "./templateManage.vue?vue&type=script&lang=js"
export * from "./templateManage.vue?vue&type=script&lang=js"
import style0 from "./templateManage.vue?vue&type=style&index=0&id=8324fb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8324fb30",
  null
  
)

export default component.exports